// extracted by mini-css-extract-plugin
export var button = "productCardSection-module--button--11b59";
export var color = "productCardSection-module--color--0fb2e";
export var container = "productCardSection-module--container--b0e1d";
export var content = "productCardSection-module--content--11a47";
export var image = "productCardSection-module--image--9a47d";
export var overlay = "productCardSection-module--overlay--d3eb3";
export var productCard = "productCardSection-module--productCard--af7ed";
export var titleButton = "productCardSection-module--titleButton--eabad";
export var wrapper = "productCardSection-module--wrapper--26e57";